import universityReport from "./universityReport.vue";
export default universityReport;
